export const areOptionPropsEqual = (prevProps, nextProps) => {
  return (
    prevProps.isFocused === nextProps.isFocused &&
    prevProps.isDisabled === nextProps.isDisabled &&
    prevProps.isSelected === nextProps.isSelected &&
    prevProps.data === nextProps.data &&
    prevProps.lastSelected === nextProps.lastSelected
  );
};
